<div class="global-dialog-container">
  <div mat-dialog-title>
    {{ title }}
    <div class="title-close" tabindex="0" (keydown.enter)="onCancel()" role="button" aria-label="Close dialog">
      <mat-icon (click)="onCancel()" (keydown.enter)="onCancel()" aria-hidden="true">close</mat-icon>
      <span class="title-close__label" mat-dialog-close>Close</span>
    </div>
  </div>
  <div mat-dialog-content [ngClass]="centerContent ? 'global-dialog-content-center' : 'global-dialog-content'">
    <mat-icon *ngIf="showIcon" aria-hidden="true">{{ iconName }}</mat-icon>
    <div [innerHTML]="content"></div>
  </div>
  <div class="global-dialog-actions" [class.global-dialog-actions--right]="showButtonsRight">
    <div class="download-document" *ngIf="this.showDownload" tabindex="0" (keydown.enter)="doanloadDocument()" role="button" aria-label="Download this document">
      <mat-icon (click)="doanloadDocument()" (keydown.enter)="doanloadDocument()" aria-hidden="true">download</mat-icon>
      <div (click)="doanloadDocument()" (keydown.enter)="doanloadDocument()">Download this document</div>
      <a
        #document
        href="/assets/data/terms-and-conditions.pdf"
        aria-label="Download this document in PDF"
        download="terms-and-conditions"
        [style.visibility]="'hidden'"
        >Download this document</a
      >
    </div>
    <mat-checkbox *ngIf="showSignup" (change)="changeCheck($event)">I agree to the Terms and Conditions</mat-checkbox>
    <div *ngIf="!showSignup" class="action-container">
      <button *ngIf="showCancel" class="secondary-action-button" (click)="onCancel()" cdkFocusInitial>
        {{ cancelLabel }}
      </button>
      <button class="primary-action-button" (click)="onAgree()" attr.aria-label="{{ onAgreeLabel }}" cdkFocusInitial>
        {{ buttonLabel }}
      </button>
    </div>
    <div *ngIf="showSignup" class="action-container">
      <button *ngIf="showCancel" class="secondary-action-button" (click)="onCancel()" cdkFocusInitial>
        {{ cancelLabel }}
      </button>
      <button [disabled]="notChecked" class="primary-action-button tocBtn" (click)="signUp()" cdkFocusInitial>
        {{ buttonLabel }}
      </button>
    </div>
  </div>
</div>
